import React, { useEffect, useState, useCallback } from "react";
import AccordionCard from "../AccordionCard";
import { BsPersonFillGear } from "react-icons/bs";
import {
  checkCredentials,
  getLinkedAccountList,
} from "../../services/clientMasterAccountService";
import handleApiError from "../../helpers/handleApiError";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { emails, viewStates } from "../../constants";
import { RetryIcon } from "../Utility/RetryIcon";
import { LoadingSpinner } from "../Utility/LoadingSpinner";
import { toast } from "react-toastify";
import {
  isMainAccount,
  isMainClientAccount,
  isSubAccount,
  shouldFetchAccountList,
} from "../../services/accountService";

const AccountClaimerModal = ({
  show,
  handleClose,
  setLoading,
  fetchLinkedAccounts,
}) => {
  const history = useHistory();
  const [accountToClaimInfo, setAccountToClaimInfo] = useState({
    username: "",
    password: "",
  });

  const initializeFormData = () => {
    setAccountToClaimInfo({
      username: "",
      password: "",
    });
  };

  const handleClickCancel = () => {
    handleClose();
    initializeFormData();
  };

  const handleChangeAccountToClaimInfo = (e) => {
    setAccountToClaimInfo({
      ...accountToClaimInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitClaimAccountRequest = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await checkCredentials(accountToClaimInfo);
      handleClose();
      toast.success(
        `Account ${accountToClaimInfo.username} was claimed successfully.`
      );
      fetchLinkedAccounts();
      initializeFormData();
      // console.log("Attempting to claim");
    } catch (ex) {
      if (ex.response.status === 401) {
        toast.warn(
          "No account found for the given username and password combination."
        );
      } else {
        handleApiError(ex, history);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Linking Account</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmitClaimAccountRequest}>
        <Modal.Body>
          <DiliTextCP
            label="Account Username"
            className="form-group col-12"
            name="username"
            value={accountToClaimInfo.username}
            onChange={handleChangeAccountToClaimInfo}
          />
          <DiliTextCP
            label="Account Password"
            className="form-group col-12"
            name="password"
            type="password"
            value={accountToClaimInfo.password}
            onChange={handleChangeAccountToClaimInfo}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClickCancel}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Link Account
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export const AccountManagement = ({
  setLoading,
  linkedAccounts,
  setLinkedAccounts,
  decodedToken,
}) => {
  const history = useHistory();
  const [viewState, setViewState] = useState(viewStates.loading);
  const [showAccountClaimerModal, setShowAccountClaimerModal] = useState(false);
  const handleOpenAccountClaimerModal = () => {
    setShowAccountClaimerModal(true);
  };
  const handleCloseAccountClaimerModal = () => {
    setShowAccountClaimerModal(false);
  };

  const fetchLinkedAccounts = useCallback(async () => {
    try {
      if (viewState !== viewStates.loading) {
        setViewState(viewStates.loading);
      }
      if (shouldFetchAccountList(decodedToken)) {
        const { data: linkedAccountsArray } = await getLinkedAccountList();
        // console.log(linkedAccountsArray);
        if (linkedAccountsArray.length > 0) {
          setLinkedAccounts(linkedAccountsArray);
          setViewState(viewStates.success);
        } else {
          setViewState(viewStates.nodata);
        }
      }
      // console.log(linkedAccounts);
      // setViewState(viewStates.error);
    } catch (ex) {
      handleApiError(ex, history);
      setViewState(viewStates.error);
    }
  }, [decodedToken, history]); //WARNING: adding viewState to the dependency list, while keeping this function in the useEffect dependency list will get it stuck in a loop. Now React gives a warning anyway. Need to look into how to restructure this to avoid this warning but don't think it's necessary.

  useEffect(() => {
    fetchLinkedAccounts();
  }, [fetchLinkedAccounts]); //honestly, we really don't want it to rerun when this function is updated, but put it here to have react stop giving a warning.

  // console.log(linkedAccountsList);

  return (
    <>
      <AccountClaimerModal
        show={showAccountClaimerModal}
        handleClose={handleCloseAccountClaimerModal}
        setLoading={setLoading}
        fetchLinkedAccounts={fetchLinkedAccounts}
      />
      <AccordionCard
        eventKey={"accountManagement"}
        title="Account Management"
        icon={() => (
          <BsPersonFillGear style={{ fontSize: "24px", marginRight: "10px" }} />
        )}
      >
        {isMainClientAccount(decodedToken) ? (
          decodedToken?.IsMainAccount ? (
            <div className="col-12">
              <div className="col-12">
                <div className="">
                  Click the <span className="font-600">Link Account</span>{" "}
                  button to authenticate and link a new account.
                </div>
                <div className="row align-items-center py-2">
                  <div className="col-12 col-md-8 pb-1 pb-md-0">
                    <span className="client-profile-info-display-header">
                      Linked Accounts
                    </span>
                    <span className="text-note ml-2">
                      {/* <div
                    style={{
                      display: "inline-block",
                      backgroundColor: "rgba(0,0,0,.3)",
                      height: ".35rem",
                      width: ".35rem",
                      borderRadius: "10000px",
                      margin: "0px 3px 2px 5px",
                      // marginBottom: "-3px",
                    }}
                  ></div> */}
                      - {linkedAccounts.length}
                    </span>
                  </div>
                  <div className="col-12 col-md-4 text-right pb-1 pb-md-0">
                    <button
                      className="btn btn-primary button-md-full-width"
                      type="button"
                      onClick={handleOpenAccountClaimerModal}
                    >
                      Link Account
                    </button>
                  </div>
                </div>
                <div
                  className="custom-scrollbar"
                  style={{
                    boxShadow: "0px 0px 3px rgba(0,0,0,.1) inset",
                    borderRadius: "3px",
                    outline: "1px solid rgba(0,0,0,.1)",
                    backgroundColor: "rgb(252,252,252)",
                    height: "15rem",
                    overflow: "auto",
                  }}
                >
                  {viewState === viewStates.loading && (
                    <div
                      style={{
                        display: "grid",
                        height: "100%",
                        placeContent: "center",
                      }}
                    >
                      <LoadingSpinner
                        title="Loading Linked Accounts"
                        spinnerClassAppend="text-note"
                      />
                    </div>
                  )}
                  {viewState === viewStates.nodata && (
                    <div
                      style={{
                        display: "grid",
                        height: "100%",
                        placeContent: "center",
                      }}
                    >
                      No Linked Accounts
                    </div>
                  )}
                  {viewState === viewStates.error && (
                    <div
                      style={{
                        display: "grid",
                        height: "100%",
                        placeContent: "center",
                        textAlign: "center",
                      }}
                    >
                      There was an issue retrieving Linked Accounts.
                      <br />
                      Please try again.
                      <div>
                        <RetryIcon onClick={fetchLinkedAccounts} />
                      </div>
                    </div>
                  )}
                  {viewState === viewStates.success && (
                    <div className="row m-0 p-3">
                      {linkedAccounts.map((linkedAccount, index) => {
                        return (
                          <div
                            className="col-xs-12 col-md-6 col-lg-4 p-2"
                            key={linkedAccount.username + "-" + index}
                          >
                            <div
                              className="bg-main"
                              style={{
                                boxShadow: "0px 1px 3px 0px rgba(0,0,0,.3)",
                                borderRadius: "3px",
                              }}
                            >
                              <div className="col-12 text-center border-bottom">
                                {linkedAccount.masterName}
                              </div>
                              <div className="col-12 text-center">
                                {linkedAccount.clientId}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div style={{ paddingLeft: "2rem" }}>
              Account Management is only available for main accounts. If you
              need the ability to link other accounts to this account, please
              contact {emails.supportEmail}.
            </div>
          )
        ) : (
          <div style={{ paddingLeft: "2rem" }}>
            Please switch to your main account to access Account Management.
          </div>
        )}
      </AccordionCard>
    </>
  );
};
